import type { BreadcrumbDefinition } from '@ipen-portal/plugin-navigation-react';

export const entitiesOfSameKindAndType: BreadcrumbDefinition['siblingsExtractor'] =
  entity =>
    (entity.kind && entity.spec && typeof entity.spec.type === 'string'
      ? { filter: { 'kind': entity.kind, 'spec.type': entity.spec.type } }
      : null);
